const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path fill-rule="evenodd" d="M3.75 3a.75.75 0 0 0-1.5 0v18c0 .414.336.75.75.75h18a.75.75 0 0 0 0-1.5H3.75zm18 1a.75.75 0 0 0-1.5 0c0 7.318-5.932 13.25-13.25 13.25a.75.75 0 0 0 0 1.5c8.146 0 14.75-6.604 14.75-14.75" clip-rule="evenodd"/></svg>';
export {
  e as w
};
